import React from "react";
import AppModal from "../common/AppModal";
import { Alert } from "@mui/material";
import UpdatePaymentIntegrationForm from "../../forms/UpdatePaymentIntegrationForm";

const PaymentIntegrationModal = ({ open, onClose, config, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Payment Gateway Setup"
      width="sm"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <UpdatePaymentIntegrationForm config={config} loading={loading} />
    </AppModal>
  );
};

export default PaymentIntegrationModal;
